import type { PlaybackRate } from '@mote/helpers'
import { PLAYBACK_RATES } from '@mote/helpers'
import styled from '@xstyled/styled-components'
import { Button } from '../button'

export interface PlaybackRateButtonProps {
  playbackRate: PlaybackRate
  onClick: (playbackRate: PlaybackRate, index: number) => void
}

export const PlaybackRateButton = (
  props: PlaybackRateButtonProps
): JSX.Element => {
  const currentRateIndex = PLAYBACK_RATES.findIndex(
    rate => rate === props.playbackRate
  )
  const nextIndex = (currentRateIndex + 1) % PLAYBACK_RATES.length

  return (
    <StyledButton
      //@ts-expect-error
      size='sm'
      variant='soft'
      data-testid='mote-player-playback-rate-button'
      onClick={() => props.onClick(PLAYBACK_RATES[nextIndex], nextIndex)}
      text={`${props.playbackRate.toFixed(1)}x`}
      aria-label='Playback rate'
      aria-valuenow={props.playbackRate.toFixed(1)}
    />
  )
}

const StyledButton = styled(Button)`
  width: 32px;
  height: 24px;
  padding: 0;
  flex-shrink: 0;

  .button-text {
    font-size: xs;
    line-height: md;
  }
`
